import { ApiGetPatientsResponse, ApiPatientRequest, ApiPatientResponse } from 'src/app/core/models';

const patientOne: ApiPatientResponse = {
  patientId: 1000,
  firstName: 'JOHN',
  lastName: 'SMITH',
  verifiedHipaa: true,
  acceptedTermsAndConditions: true,
  consentedToMarketing: true,
  refusedGenericMedications: true,
  reorder: true,
  isPharmacyPatient: true,
};
const patientTwo: ApiPatientResponse = {
  patientId: 1001,
  firstName: 'JANE',
  lastName: 'WILLIAMS',
  verifiedHipaa: true,
  acceptedTermsAndConditions: true,
  consentedToMarketing: true,
  refusedGenericMedications: false,
  reorder: true,
  isPharmacyPatient: true,
};

export const getPatients = (): ApiGetPatientsResponse => {
  return [patientOne, patientTwo];
};

export const getPatient = (): ApiPatientResponse[] => {
  return [patientOne];
};

export const updatePatient = (_: any, body: ApiPatientRequest): ApiPatientResponse[] => {
  const { acceptedTermsAndConditions, consentedToMarketing } = body;

  if (typeof acceptedTermsAndConditions === 'boolean') {
    patientOne.acceptedTermsAndConditions = acceptedTermsAndConditions;
  }

  if (typeof consentedToMarketing === 'boolean') {
    patientOne.consentedToMarketing = consentedToMarketing;
  }

  return [patientOne];
};
